import React from 'react'
import { Modal } from 'antd'
import { useDispatch, useSelector } from 'react-redux'
import { revertChangedSettings, setPreferences } from '../../Redux/slices/Preferences/preferences'
import { useComponentLocale } from '../../hooks/useComponentLocale'

export default function AcceptModal() {
	const { isAcceptModalVisible, isFetchingData } = useSelector((state) => state.preferences)
	const dispatch = useDispatch()

	const getLocale = useComponentLocale()

	const doYouWantSaveLocale = getLocale({ component: 'settings_modal', section: 'do_you_want_save' })
	const youHaveSelectedLocale = getLocale({ component: 'settings_modal', section: 'you_have_selected' })
	const saveNewLocale = getLocale({ component: 'settings_modal', section: 'do_you_want_save_new' })
	const saveLocale = getLocale({ component: 'common_buttons', section: 'save' })
	const discardLocale = getLocale({ component: 'common_buttons', section: 'discard' })

	return (
		<Modal
			title={doYouWantSaveLocale}
			open={isAcceptModalVisible}
			onOk={async () => {
				await dispatch(setPreferences())
			}}
			confirmLoading={isFetchingData}
			onCancel={() => {
				dispatch(revertChangedSettings())
			}}
			okText={saveLocale}
			cancelText={discardLocale}
			destroyOnClose
		>
			<p>{youHaveSelectedLocale}</p>
			<p>{saveNewLocale}</p>
		</Modal>
	)
}
